import api from "../helpers/axios";

class FacilityThemeService {
  
    async getFacilityThemeById(facilityNumber) {
        try {
        const response = await api.get(`/facility_theme/${facilityNumber}`);
        return response?.data;
        } catch (error) {
        console.error(`Error fetching facility theme with facility number ${facilityNumber}:`, error);
        throw error;
        }
    }

    async createFacilityTheme(facilityThemeData) {
        try {
          const response = await api.post('/facility_theme/', facilityThemeData);
          return response.data;
        } catch (error) {
          console.error('Error creating facility theme :', error);
          throw error;
        }
      }

    async updateFacilityTheme(facilityNumber, configData) {
        try {
          const response = await api.patch(`/facility_theme/${facilityNumber}`, configData);
          return response.data;
        } catch (error) {
          console.error(`Error updating facility theme with ID ${facilityNumber}:`, error);
          throw error;
        }
      }
}

export default new FacilityThemeService();